<div class="onboarding-wrapper">
    <div class="onboarding-container">
        <!-- Content area -->

        <!-- Content area -->
        <div class="onboarding-content" @fadeSlide>
            <!-- Current slide -->
            <div class="slide" [@slideChange]="currentSlide" *ngFor="let slide of slides; let i = index"
                [class.active]="i === currentSlide">

                <!-- Icon illustration -->
                <div class="slide-icon">
                    <!-- Chart icon - GREEN -->
                    <svg *ngIf="slide.icon === 'chart'" viewBox="0 0 200 200" class="icon-svg">
                        <circle cx="100" cy="100" r="95" fill="#E8F5E9" opacity="0.5" />
                        <rect x="65" y="90" width="15" height="50" rx="3" fill="#2D7A4F" />
                        <rect x="92.5" y="70" width="15" height="70" rx="3" fill="#4CAF70" />
                        <rect x="120" y="50" width="15" height="90" rx="3" fill="#66BB6A" />
                        <path d="M 60 85 L 85 60 L 110 70 L 135 40" stroke="#1B5E37" stroke-width="3" fill="none"
                            stroke-linecap="round" />
                        <circle cx="60" cy="85" r="5" fill="#2D7A4F" />
                        <circle cx="85" cy="60" r="5" fill="#4CAF70" />
                        <circle cx="110" cy="70" r="5" fill="#4CAF70" />
                        <circle cx="135" cy="40" r="5" fill="#66BB6A" />
                    </svg>

                    <!-- Users icon - GREEN -->
                    <svg *ngIf="slide.icon === 'users'" viewBox="0 0 200 200" class="icon-svg">
                        <circle cx="100" cy="100" r="95" fill="#E8F5E9" opacity="0.5" />
                        <circle cx="75" cy="70" r="18" fill="#81C784" opacity="0.9" />
                        <path d="M 75 92 C 60 92 50 100 50 110 L 50 120 L 100 120 L 100 110 C 100 100 90 92 75 92 Z"
                            fill="#A5D6A7" opacity="0.9" />
                        <circle cx="125" cy="75" r="18" fill="#66BB6A" opacity="0.9" />
                        <path
                            d="M 125 97 C 110 97 100 105 100 115 L 100 125 L 150 125 L 150 115 C 150 105 140 97 125 97 Z"
                            fill="#81C784" opacity="0.9" />
                        <circle cx="100" cy="55" r="20" fill="#2D7A4F" />
                        <path d="M 100 80 C 83 80 72 89 72 100 L 72 112 L 128 112 L 128 100 C 128 89 117 80 100 80 Z"
                            fill="#4CAF70" />
                    </svg>

                    <!-- Offline icon - GREEN -->
                    <svg *ngIf="slide.icon === 'offline'" viewBox="0 0 200 200" class="icon-svg">
                        <circle cx="100" cy="100" r="95" fill="#E8F5E9" opacity="0.5" />
                        <rect x="60" y="50" width="80" height="100" rx="8" fill="#FFF" stroke="#2D7A4F"
                            stroke-width="3" />
                        <circle cx="100" cy="140" r="4" fill="#2D7A4F" />
                        <path d="M 75 40 Q 75 30 85 30 L 115 30 Q 125 30 125 40" fill="none" stroke="#2D7A4F"
                            stroke-width="3" stroke-linecap="round" />
                        <path d="M 80 80 L 120 80 M 80 95 L 110 95 M 80 110 L 115 110" stroke="#4CAF70"
                            stroke-width="2.5" opacity="0.5" />
                        <circle cx="100" cy="72" r="15" fill="#C8E6C9" />
                        <path d="M 93 72 L 100 78 L 113 62" stroke="#2D7A4F" stroke-width="3" fill="none"
                            stroke-linecap="round" stroke-linejoin="round" />
                    </svg>

                    <!-- Map icon - GREEN -->
                    <svg *ngIf="slide.icon === 'map'" viewBox="0 0 200 200" class="icon-svg">
                        <circle cx="100" cy="100" r="95" fill="#E8F5E9" opacity="0.5" />
                        <rect x="45" y="60" width="110" height="85" rx="5" fill="#FFF" stroke="#2D7A4F"
                            stroke-width="3" />
                        <path d="M 70 90 Q 80 75 95 75 Q 110 75 120 90 Q 130 105 140 125" stroke="#4CAF70"
                            stroke-width="2.5" fill="none" opacity="0.5" />
                        <circle cx="70" cy="90" r="6" fill="#4CAF70" />
                        <circle cx="95" cy="75" r="6" fill="#2D7A4F" />
                        <circle cx="120" cy="90" r="6" fill="#4CAF70" />
                        <circle cx="140" cy="125" r="6" fill="#66BB6A" />
                        <path d="M 95 60 L 85 80 L 105 80 Z" fill="#2D7A4F" />
                        <circle cx="95" cy="70" r="4" fill="#FFF" />
                    </svg>
                </div>

                <!-- Message -->
                <div class="slide-content">
                    <h2 class="slide-message">{{ slide.message }}</h2>
                </div>
            </div>

            <!-- Progress indicators -->
            <div class="progress-dots">
                <button *ngFor="let slide of slides; let i = index" class="dot" [class.active]="i === currentSlide"
                    (click)="goToSlide(i)" [attr.aria-label]="'Aller au slide ' + (i + 1)" type="button">
                </button>
            </div>

            <!-- Navigation - Both buttons on same row -->
            <div class="navigation">
                <button class="skip-button" (click)="skipOnboarding()" type="button">
                    Passer
                </button>

                <button class="next-button" (click)="nextSlide()" type="button">
                    {{ buttonText }}
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                        <path d="M7 4L13 10L7 16" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"
                            stroke-linejoin="round" />
                    </svg>
                </button>
            </div>
        </div>
    </div>
</div>